import { Pressable, Text, View } from "react-native"
import styles from "./Menus.styles"
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons"
import { stdCouleurBleu } from "@commonStyle"

type MenuProfilProps = {
  onProfilClick: () => void,
  onFicheAgentClick?: () => void,
  onCollectiviteClick?: () => void,
  onLogoutClick: () => void,
}

export default function MenuProfil({ onProfilClick, onFicheAgentClick, onCollectiviteClick, onLogoutClick }: MenuProfilProps){
  return (
    <View style={styles.menuProfileContainer}>
      <Pressable onPress={onProfilClick} style={styles.menuProfileItem} testID="BT_MENU_PROFIL">
        <Text style={styles.menuItemText}>Profil</Text>
        <MaterialCommunityIcons name="account" color={stdCouleurBleu} size={25} />
      </Pressable>
      {onFicheAgentClick && (
        <Pressable onPress={onFicheAgentClick} style={styles.menuProfileItem} testID="BT_MENU_FICHES_AGENT">
          <Text style={styles.menuItemText}>Fiches Agent</Text>
          <MaterialCommunityIcons name="file-account" color={stdCouleurBleu} size={25} />
        </Pressable>
      )}
      {onCollectiviteClick && (
        <Pressable onPress={onCollectiviteClick} style={styles.menuProfileItem} testID="BT_MENU_COLLECTIVITES">
          <Text style={styles.menuItemText}>Collectivités</Text>
          <MaterialCommunityIcons name="home-city" color={stdCouleurBleu} size={25} />
        </Pressable>
      )}
      <Pressable onPress={onLogoutClick} style={styles.menuProfileItem} testID="BT_LOGOUT">
        <Text style={styles.menuItemText}>Deconnexion</Text>
        <MaterialCommunityIcons name="power" color={stdCouleurBleu} size={25} />
      </Pressable>
    </View>
  )
}